import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';
import { FormControl, InputLabel, Select, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing(1),
    width: '97%',
    minWidth: 120,
  },
  nselect: {
    paddingLeft: 0,
  },
});

const StatementSelectQuery = graphql`
query StatementSelectQuery($accountId: UUID, $viewingAccountId: UUID, $first: Int) {
  getstatementperiods2(accountid: $accountId, viewingaccountid: $viewingAccountId, first: $first) {
    totalCount
    nodes {
      statementTitle
      statementRange
      startTs
      endTs
      siId
    }
  }
}
`;

class StatementSelect extends Component {
  constructor(props) {
    super(props);

    this.initProps = null;
  }

  setStatementSelectState = (statementIdx, theNodes) => {
    if (statementIdx !== '') {
      this.props.setStatementSelectState(statementIdx, theNodes[statementIdx].startTs, theNodes[statementIdx].endTs, theNodes[statementIdx].siId);
    }
  }

  render() {
    const classes = this.props.classes;
    let statementsFound = false;
    let maxStatements = 300;
    let statementIndex = this.props.statementIndex;
    if (statementIndex == null || statementIndex < 0) {
      statementIndex = 0;
    }

    let widthOverride = null;
    if (this.props.widthOverride != null) {
      widthOverride = this.props.widthOverride;
    }

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={StatementSelectQuery}
        variables={{first: maxStatements,
                    accountId: this.props.accountId,
                    viewingAccountId: abEnvironment.getUserAttribute('a_id')}}
        render={({error, props})=> {
          if (error) {
            return (
              <FormControl  variant="standard" 
                className={classes.formControl}
                style={
                  widthOverride == null
                  ? {
                      'width': '97%'
                    }
                  : {
                      'width': widthOverride
                    }
                }
              >
                <InputLabel shrink htmlFor="statement">Statement</InputLabel>
                <Select
                  value={statementIndex}
                  inputProps={{
                    name: 'statement',
                    id: 'statement',
                  }}
                  className={classes.nselect}
                >
                  <option value="">Loading...</option>
                </Select>
              </FormControl>
            );
          } else if (props) {
            // Options from result of query
            if (props.getstatementperiods2.nodes.length !== 0) {
              statementsFound = true;
              
              var sIdx=0;
              return (
                <FormControl   variant="standard" 
                  className={classes.formControl}
                  style={
                    widthOverride == null
                    ? {
                        'width': '97%'
                      }
                    : {
                        'width': widthOverride
                      }
                  }
                >
                  <InputLabel shrink htmlFor="statement">Statement</InputLabel>
                  <Select
                    native
                    value={statementIndex}
                    inputProps={{
                      name: 'statement',
                      id: 'statement',
                    }}
                    onChange={(e) => this.setStatementSelectState(e.target.value, props.getstatementperiods2.nodes)}
                    className={classes.nselect}
                  >
                    <option key={""} value="">Select a statement...</option>
                    {/* <MenuItem value=""><em>Select a statement...</em></MenuItem> */}
                    {props.getstatementperiods2.nodes.map(n => {
                      let theIdx = sIdx;
                      sIdx ++;
                      let statementChoice = '';

                      // Omit the title if it is a previous statement, otherwise
                      // lower case it.
                      if (n.statementTitle !== 'Previous statement') {
                        statementChoice = n.statementRange + " (" + n.statementTitle.toLowerCase() + ")";
                      } else {
                        statementChoice = n.statementRange;
                      }
                      return(<option key={theIdx} value={theIdx}>{statementChoice}</option>);
                      /* return(<MenuItem value={theIdx}>{statementChoice}</MenuItem>); */
                    })}
                  </Select>
                </FormControl>
              );
            }
          }

          if (statementsFound) {
            return (
              <FormControl  variant="standard" 
                className={classes.formControl}
                style={
                  widthOverride == null
                  ? {
                      'width': '97%'
                    }
                  : {
                      'width': widthOverride
                    }
                }
              >
                <InputLabel shrink htmlFor="statement">Statement</InputLabel>
                <Select
                  value={statementIndex}
                  inputProps={{
                  name: 'statement',
                  id: 'statement',
                  }}
                  className={classes.nselect}
                >
                  <option value="">Loading...</option>
                </Select>
              </FormControl>
            );
          } else {
            return (
              <Typography variant="subtitle1" style={{marginTop: '25px'}}>
                          No statements are available yet
              </Typography>
            );
          }
        }}
      />
    );
  }
    
}

export default withStyles(styleSheet)(StatementSelect);
